import React, { useState, useMemo } from 'react';
import Select, { SingleValue } from 'react-select';
import { getCountryCode, getCountryData } from 'countries-list';
import countryList from 'react-select-country-list';

interface CountryOption {
  value: string;
  label: string;
}

interface CountrySelectorProps {
  className?: string;
  value: SingleValue<CountryOption>;
  onChange: (value: SingleValue<CountryOption>) => void;
  onBlur?: () => void;
}

const customStyles = {
  menu: (provided: any, state: any) => ({
    ...provided,
    padding: state.selectProps.padding,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    margin: state.selectProps.margin,
    backgroundColor: 'transparent', 
    minHeight: '24px',
    height: '31px', 
    borderColor: '#e3e3e3',
    padding: '0 , 4px',
    '&:hover': {
      minHeight: '24px', // 최소 높이 설정
      height: '31px', // 높이 설정
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    lineHeight: '2px',
    height: '31px',
  }),
  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition, padding: '0',
      fontSize: '14px', 
      lineHeight: '24px',
      height: '28px',
    };
  },
  input: (provided: any) => ({
    ...provided,
    lineHeight: '21px',
    height: '26px',
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '26px', 
    lineHeight: '18px',
  }),
};

const CountrySelector: React.FC<CountrySelectorProps> = ({ value, onChange, onBlur }) => {
  const options = useMemo(() => countryList().getData(), []);

  return (
    <Select
      className='bg-transparent w-full'
      options={options}
      value={value}
      onBlur={onBlur} 
      onChange={onChange}
      styles={customStyles}
      placeholder="Select a country"
    />
  );
};

export default CountrySelector;
